import React from 'react';
import { useTranslation } from 'react-i18next';
import AppStoreButtons from '../shared/AppStoreButtons';
import { CREATE_GIFT_PAGE_URL } from '../../constants/appLinks';
import '../../styles/landing/FinalCTASection.css';

const FinalCTASection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            className="landing-section landing-section--navy final-cta-section"
            aria-labelledby="final-cta-heading"
        >
            <div className="landing-container final-cta-section__inner">
                <h2 id="final-cta-heading" className="final-cta-section__title">
                    {t('finalCta.title')}
                </h2>
                <a href={CREATE_GIFT_PAGE_URL} className="btn btn--on-dark final-cta-section__btn">
                    {t('cta.createGiftPage')}
                </a>
                <AppStoreButtons variant="light" className="final-cta-section__stores" />
            </div>
        </section>
    );
};

export default FinalCTASection;
